"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var classnames_1 = __importDefault(require("classnames"));
function Cell(_a) {
    var children = _a.children, _b = _a.width, width = _b === void 0 ? 50 : _b, _c = _a.alignRight, alignRight = _c === void 0 ? false : _c, _d = _a.extraPadding, extraPadding = _d === void 0 ? false : _d, _e = _a.trimText, trimText = _e === void 0 ? false : _e, _f = _a.rowTitle, rowTitle = _f === void 0 ? false : _f;
    var mainClass = (0, classnames_1.default)("nimbus--data-list-row__item", "nimbus--data-list-row__item--".concat(width, "-width"), { "nimbus--data-list-row__item--align-right": alignRight }, { "nimbus--data-list-row__item--extra-padding": extraPadding }, { "nimbus--data-list-row__item--trim-text": trimText }, { "nimbus--data-list-row__item--row-title": rowTitle });
    return React.createElement("div", { className: mainClass }, children);
}
exports.default = Cell;
//# sourceMappingURL=Cell.js.map